import axios from "axios";

// Base URL vem de `REACT_APP_API_URL`, com produção como padrão.
//
// O padrão é o que mantém o comportamento atual: builds que não definem a
// variável — a Netlify inclusive — continuam apontando pra produção, sem
// variável nova em lugar nenhum. O CRA substitui `process.env.REACT_APP_*` em
// tempo de build, então quando a variável não existe isto vira `undefined` e o
// `||` escolhe o padrão.
//
// Existe pra revisão local ser possível: o `ALLOWED_ORIGINS` do bot em produção
// está setado sem `http://localhost:3000`, então o preflight de `localhost:3000`
// pra produção é barrado por CORS. Com a variável, `npm start` aponta pro stub
// de `scripts/stub-chat-server.js` e a tela pode ser revisada sem tocar em
// produção.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://atcheza.benthos.ai",
  timeout: 100000, // Timeout in milliseconds (e.g., 10 seconds)
});

export default api;
